import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { useDebounce } from '../../shared/CustomHooks';

const SearchContainer = styled(Box)(({ theme, sx }) => ({
  display: 'flex',
  flexDirection: 'row',
  border: '1px solid #E4E7EC',
  borderRadius: '4px',
  backgroundColor: '#FFFFFF',
  marginLeft: 0,
  height: '40px',
  width: '304px',
  marginRight: '12px',
  alignItems: 'center',
  ...sx,
}));

const SearchIconWrapper = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
}));

const SearchBarAssessment = ({
  delay,
  displayLoading,
  fetchData,
  loading,
  onChange,
  placeholder = 'Search',
  searchIcon,
  value,
  minLength = 3,
  onEnter,
  displayMinLengthErrorMsg,
}) => {
  const onClear = e => {
    onChange('');
  };

  const searchParam = useDebounce(value, delay);

  const onKeyDown = event => {
    const {
      target: { value },
      keyCode,
    } = event;
    if (keyCode === 13) {
      typeof onEnter === 'function' && onEnter();
    }
  };

  useEffect(() => {
    typeof fetchData === 'function' &&
      (searchParam.length >= minLength || searchParam === '') &&
      fetchData(searchParam);
  }, [searchParam]);

  return (
    <Box>
      <SearchContainer>
        <SearchIconWrapper>
          {searchIcon ? (
            searchIcon
          ) : (
            <SearchIcon sx={{ fontSize: 24, color: '#344054' }} />
          )}
        </SearchIconWrapper>
        <InputBase
          sx={{
            width: '100%',
            fontWeight: 400,
            fontSize: 14,
            color: 'black',
          }}
          placeholder={placeholder}
          value={value}
          inputProps={{
            sx: {
              '&::placeholder': {
                color: '#667085',
                opacity: 1,
              },
            },
            'data-testid': 'input-searchbar',
          }}
          onChange={e => {
            onChange(e.target.value);
          }}
          onKeyDown={onKeyDown}
        />

        {value && (
          <SearchIconWrapper>
            <CloseIcon
              onClick={onClear}
              sx={{ cursor: 'pointer', fontSize: '24px' }}
            />
          </SearchIconWrapper>
        )}

        {loading && displayLoading ? (
          <Box sx={{ display: 'flex', marginRight: '5px' }}>
            <CircularProgress size={20} />
          </Box>
        ) : null}
      </SearchContainer>
      {displayMinLengthErrorMsg &&
        searchParam.length < minLength &&
        searchParam.length > 0 && (
          <Box display={'flex'} pt={'10px'}>
            <Typography
              sx={{
                fontSize: 12,
                color: '"#344054"',
              }}>{`Please enter min ${minLength} character`}</Typography>
          </Box>
        )}
    </Box>
  );
};

export default SearchBarAssessment;
